export const langIsValid = (lang) => {
	const validLang = ['es','pt','en']
	return validLang.includes(lang)
}

export const companyIsValid = (company) => {
	const validCompany = ['ceusa','durafloor','portinari']
	return validCompany.includes(company)
}